<!--
  ~ Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<br/>
<h1 class="page-header">Workload Timing</h1>
<br/>
@if (loading || exporting) {
  <div>
    <br/>
    <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
  </div>
}
@if (permission()) {
  <div>
    <p-confirmDialog key="deleteRowConfirmation"></p-confirmDialog>
    @if (!loading) {
      <p-tabs [value]="safeActiveTabIndex" (valueChange)="onTabChange(+$event)">
        <p-tablist>
          <p-tab [value]="0">Programs</p-tab>
          <p-tab [value]="1">Timing Chart</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel [value]="0">
            <table style="width:100%">
              <tr>
                <td><div class="buttons" style="float: right;">
                  @if (adminPermission()) {
                    <p-button label="Add Row" (click)="addRow()" icon="pi pi-plus"
                    [loading]="!!(saving || exporting || resetting || loading)" class="gm-btn-primary mr-2"></p-button>
                  }
                  <p-button label="Reset Changes" (click)="resetChanges()" [disabled]="!dataChanged"
                    [loading]="!!(saving || exporting || resetting || loading)"
                  [severity]="!dataChanged ? 'secondary' : 'warn'" class="mr-2" icon="pi pi-replay"></p-button>
                  <p-button label="Save Programs" icon="pi pi-save" class="gm-btn-primary mr-2" (click)="saveProgramSizes()"
                    [disabled]="!dataChanged || duplicate || rowsInvalid"
                  [loading]="!!(saving || exporting || resetting || loading)"></p-button>
                  <p-button icon="pi pi-download" (onClick)="exportReport()" [loading]="!!(saving || exporting || resetting || loading)"
                  label="Download Report" class="gm-btn-primary mr-2"></p-button>
                </div></td>
              </tr>
            </table>
            <p>
              <ag-grid-angular #workloadGrid style="width: 100%; height: 80vh;" class="ag-theme-balham"
                [rowHeight]="35" [columnDefs]="cols" [undoRedoCellEditing]="true"
                [enableCellTextSelection]="true" [undoRedoCellEditingLimit]="50"
                [rowData]="rowDataSignal()" [pagination]="true" rowSelection="multiple"
                suppressRowClickSelection="true" [paginationPageSize]="1000"
                [paginationPageSizeSelector]="[100, 200, 300, 500, 1000, 2000, 5000]"
                [autoSizeStrategy]="autoSizeStrategy" [rowClassRules]="rowClassRules"
                [defaultColDef]="defaultColDef" (cellEditingStopped)="cellEditingStopped($event)"
              (gridReady)="onWorkloadGridReady($event);"></ag-grid-angular>
            </p>
          </p-tabpanel>
          <p-tabpanel [value]="1">
            <h4>Bar Chart</h4>
            @if (!hasChartData()) {
              <div>No Program Size Data</div>
            }
            @if (safeActiveTabIndex === 1 && hasChartData()) {
              <app-svg-bar-chart
                [data]="chartData"
                [width]="1600"
              [height]="500"></app-svg-bar-chart>
            }
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    }
  </div>
}
